import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class PreLoader extends Phaser.State {

    public static currentInstance: PreLoader;

    private scaledItemsContainer: Phaser.Group;
    private preloadBar: Phaser.Sprite;
    
    public init(): void {
        
        PreLoader.currentInstance = this;
    }
    
    public preload(): void {

        Phaser.Canvas.setBackgroundColor(this.game.canvas, "#000000");

        this.generateBitmapData();
        this.composeScene();
        this.loadAssets();
    }

    public create(): void {

        this.game.add.tween(this.scaledItemsContainer)
            .to ({alpha: 0}, 350, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(GameManager.onGameAssetsLoaded, GameManager);
    }
    
    public shutdown(): void {
        
        PreLoader.currentInstance = this;
        
        super.shutdown();
    }

    private updateLoadedPercentage(): void {

        this.preloadBar.scale.x = this.load.progress / 100 * 8.94;
    }

    private generateBitmapData(): void {

        let bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.BLACK_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#000000";
        bmd.ctx.fill();
        
        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.WHITE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FFFFFF";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.RED_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#ac0428";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.ORANGE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FF9900";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.YELLOW_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FFFF00";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#00FF00";
        bmd.ctx.fill();
    }

    private composeScene(): void {

        this.add.text(5, 5, "ABCDEFG", { font: "50px Eczar", fill: "#ff1a2c"});

        this.add.image(0, 0, "background");
        this.add.image(0, 0, "background_shadow");
        const lowerShadow = this.add.image(0, GameConstants.GAME_HEIGHT, "background_shadow");
        lowerShadow.scale.y = -1;

        this.scaledItemsContainer = this.add.group();
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT * 2 / 3;
        this.scaledItemsContainer.scale.y = GameVars.scaleY;

        const preloadBarCapsuleShadow = new Phaser.Sprite(this.game, 3.5, 3.5, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        preloadBarCapsuleShadow.scale.set(9, .3);
        preloadBarCapsuleShadow.anchor.set(.5);
        preloadBarCapsuleShadow.alpha = .45;
        this.scaledItemsContainer.add(preloadBarCapsuleShadow);

        const preloadBarCapsule = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.WHITE_SQUARE));
        preloadBarCapsule.scale.setTo(9, .3);
        preloadBarCapsule.anchor.set(.5);
        this.scaledItemsContainer.add(preloadBarCapsule);

        this.preloadBar = new Phaser.Sprite(this.game, -286.2, 0, this.game.cache.getBitmapData(GameConstants.RED_SQUARE));
        this.preloadBar.scale.setTo(0, .24);
        this.preloadBar.anchor.set(0, .5);
        this.scaledItemsContainer.add(this.preloadBar);
    }
    
    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.image("logo", "assets/freezenovagames.png");

        this.load.audiosprite("audio-sprite", ["assets/audio/audiosprite.mp3", "assets/audio/audiosprite.ogg"], "assets/audio/audiosprite.json");

        this.load.onFileComplete.add(this.updateLoadedPercentage, this);
    }
}
